import { render, staticRenderFns } from "./dashboard-customer.vue?vue&type=template&id=861be790&"
import script from "./dashboard-customer.vue.ts?vue&type=script&lang=ts&"
export * from "./dashboard-customer.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports